import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges
} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PaymentInfo, StaticMethods} from '../../model/GeneralModels';
import {AppSettingsService} from '../../services/app-settings.service';
import {FinanceService} from '../../services/finance.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-finance-invoice-div',
  template: `
    <div class="factor elem" *ngIf="show">
      <div class="wrap" (clickOutside)="clickOutSide()" [delayClickOutsideInit]="true">
        <div *ngIf="!inProgress">
          <div class="row">
            <div class="col col-12">
              <div class="head">
                <i class="icon ico-shopping-cart-outline"></i>
                <h2>پرداخت حق بیمه</h2>
                <p>همین الان حق بیمه خودتون را پرداخت کنید</p>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="paymentInfo.personCount">
            <div class="col col-12">
              <div class="txt-justify">
                <p>این صورتحساب برای <span class="person-count">{{paymentInfo.personCount}}</span> نفر از بیمه گذاران
                  صادر
                  شده است.
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div *ngIf="paymentInfo.paymentMode === 'CASH' && !paymentInfo.noDiscounts " class="col col-12">
              <app-input-field
                [Icon]="false"
                [fieldLabel]="'کد تخفیف'"
                [fieldName]="'discountCode'"
                [Group]="Group"
                [dataType]="['text']"
                [button]="false"
                [clearButton]="true"
                [buttonLabel]="'اعمال'"
                [inProgress]="inProgress">
              </app-input-field>
            </div>
          </div>
          <div class="row" style="height: 45px;">
            <div class="col col-12">
              <div class="col col-6">
                <h3 style="line-height: 33px;">مبلغ کل</h3>
              </div>
              <div class="col col-6">
                <div>
                <span class="mark"
                      dir="ltr">{{paymentInfo.discountedAmountString}}</span>
                  <span style="float: left">تومان</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="height: 45px;">
            <div class="col col-12">
              <div class="col col-6">
                <h3 style="line-height: 33px;">نوع پرداخت</h3>
              </div>
              <div class="col col-6">
                <div>
                <span dir="ltr"
                      style="float: left">{{settings.translateEnglish(paymentInfo.paymentMode, translation)}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="height: 45px;" *ngIf="paymentInfo.visitCost">
            <div class="col col-12">
              <div class="col col-6">
                <h3 style="line-height: 33px;">هزینه ویزیت</h3>
              </div>
              <div class="col col-6">
                <div>
                  <span class="mark" dir="ltr">{{paymentInfo.visitCost}}</span>
                  <span style="float: left">تومان</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="paymentInfo.discountSumString !== ''">
            <div class="col col-12">
              <div class="col col-6">
                <h3 style="line-height: 33px;">تخفیفات</h3>
              </div>
              <div class="col col-6">
                <div>
                  <span class="mark" dir="ltr">{{paymentInfo.discountSumString}}</span>
                  <span style="float: left">تومان</span>
                </div>
              </div>
            </div>
            <ol>
              <li *ngFor="let discount of paymentInfo.discountsList">
                <span class="discounts">{{discount}}</span>
              </li>
            </ol>
          </div>
          <div class="row" *ngIf="paymentInfo.addedValue">
            <div class="col col-6">
              <h3 style="line-height: 33px;">{{paymentInfo.addedValue.label}}</h3>
            </div>
            <div class="col col-6">
              <div>
                <span class="mark" dir="ltr">{{paymentInfo.addedAmountString}}</span>
                <span style="float: left">تومان</span>
              </div>
            </div>
          </div>
          <div class="row" style="height: 45px;">
            <div class="col col-12">
              <div class="col col-6">
                <h3 style="line-height: 33px;">مبلغ قابل پرداخت</h3>
              </div>
              <div class="col col-6">
                <div>
                  <span class="mark" dir="ltr">{{paymentInfo.amountString}}</span>
                  <span style="float: left;">تومان</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="height: 45px;">
            <app-radio-button [translation]="translation" [fieldName]="'paymentPort'" [Group]="Group"
                              [list]="paymentInfo.availablePaymentPorts"></app-radio-button>
          </div>
          <div class="row">
            <div class="col col-12"
                 style="text-align: right">
              <span>شماره فاکتور</span>
              <span
                class="resnum">{{(paymentInfo.resnum ? (paymentInfo.resnum + ' - ') : '') + ' طرح ' + paymentInfo.offerName}}</span>
            </div>
          </div>
          <div class="row" style="float: left">
            <div style="float: left">
              <div class="pull-right" style="margin-left: 2px" *ngIf="paymentInfo && paymentInfo.availablePaymentModes.length">
                <a class="link link-pay">
                  <div (click)="goToPayment('INSTALLMENT')"
                       [ngClass]="paymentInfo.paymentMode === 'INSTALLMENT'? 'push push-enabled' : 'push push-disabled'"
                       style="height: 32px">
                    <i class="icon ico-shopping-bag-outline"></i>
                    <span>{{paymentInfo.paymentMode === 'INSTALLMENT' ? 'پرداخت کنید' : 'قسطی'}}</span>
                  </div>
                </a>
              </div>
              <div class="pull-left">
                <a class="link link-pay">
                  <div (click)="goToPayment('CASH')" class="push"
                       [ngClass]="paymentInfo.paymentMode === 'CASH'? 'push push-enabled' : 'push push-disabled'"
                       style="height: 32px">
                    <i class="icon ico-shopping-bag-outline"></i>
                    <span>{{paymentInfo.paymentMode === 'CASH' ? 'پرداخت کنید' : 'نقدی'}}</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="inProgress" class="loader-div">
          <mat-spinner class="loader"></mat-spinner>
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css'
  ],
  styles: [`
    .factor .link {
      white-space: pre-wrap !important;
    }

    .icon {
      color: #fff !important;
    }

    .push {
      padding: 0 15px;
      overflow: hidden;
      position: inherit !important;
      top: 0;
      left: 0;
      bottom: 0;
      text-align: center;
      line-height: 38px;
      color: #fff;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-radius: 3px;
      min-width: 106px;
    }

    .loader {
      left: 50%;
      top: 50%;
    }

    .loader-div {
      height: 50px;
    }

    .push-enabled {
      background-color: #12b886 !important;
    }

    .push-disabled {
      background-color: #537EC5 !important;
    }

    .span-enabled:before {
      visibility: hidden;
    }

    .span-enabled:after {
      content: 'پرداخت کنید';
    }
  `]
})
export class FinanceInvoiceDivComponent implements OnInit, AfterContentChecked, OnChanges {
  @Input() RequestID: number;
  @Input() show: boolean;
  @Input() productName: string;
  @Input() paymentMode;
  @Output() OnClickOutSide = new EventEmitter<void>();
  @Input() dialog: MatDialog;
  translation: any = {};
  paymentInfo: PaymentInfo = new PaymentInfo();
  errorMessage: string;
  Group: FormGroup = new FormGroup({
    paymentPort: new FormControl(['']),
    discountCode: new FormControl([''])
  });
  inProgress: boolean;

  constructor(private cdRef: ChangeDetectorRef,
              public settings: AppSettingsService,
              private service: FinanceService) {
  }

  ngOnInit() {
    this.generateInvoice(null, this.paymentMode ? this.paymentInfo : 'CASH');
  }

  goToPayment($event) {
    if ($event !== this.paymentInfo.paymentMode) {
      this.generateInvoice(this.Group.controls.discountCode.value, $event);
    } else {
      if (!this.paymentInfo.resnum) {
        this.generateInvoice(this.Group.controls.discountCode.value, $event, this.Group.controls.paymentPort.value, () => {
          this.goToPayment(this.paymentInfo.paymentMode);
        });
      } else {
        StaticMethods.redirectToPayment(this.paymentInfo, this.dialog, this.service, this.productName, $event,
          (reload, newPaymentMode) => {
            if (reload) {
              this.generateInvoice(this.Group.controls.discountCode.value, newPaymentMode);
            } else {
              this.OnClickOutSide.emit();
            }
          });
      }
    }
  }

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  clickOutSide() {
    this.OnClickOutSide.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (this.paymentInfo && this.paymentInfo.addedValue) {
    //   this.paymentInfo.addedValue.addedAmountString = StaticMethods.numberWithCommas(this.paymentInfo.addedValue.addedAmount);
    // }
  }

  generateInvoice(discountCode, paymentMode, paymentPort?: string, cb?: any) {
    this.inProgress = true;
    this.service.invoice(
      this.RequestID,
      this.productName,
      discountCode,
      paymentMode,
      paymentPort
    ).subscribe(response => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        this.paymentInfo.setData(response.data);
        this.Group.controls.paymentPort.patchValue(this.paymentInfo.availablePaymentPorts[0]);
        this.inProgress = false;
        if (cb) {
          cb();
        }
      }
    }, error => {
      this.inProgress = false;
      console.log(error);
      console.log(this.paymentInfo);
      if (this.paymentInfo.amount) {
        this.errorMessage = error.message;
      } else {
        this.OnClickOutSide.emit();
      }
    });
  }
}
